import GroupApi from '@/api/Group'
import type { FetchParams, ParamType } from '@/api/types.ts'
import { queryOptions, useQuery } from '@tanstack/react-query'

export function useFetchGroup(params: FetchParams) {
  return useQuery({
    queryKey: ['fetch-group', params],
    queryFn: () => GroupApi.fetch([], params),
  })
}

export function getGroupQueryOptions(id: ParamType) {
  return queryOptions({
    queryKey: ['get-group', id],
    queryFn: () => GroupApi.get(id),
  })
}

export function useGetGroup(id: ParamType) {
  return useQuery(getGroupQueryOptions(id))
}

export function useFetchRelatedUsers(id: ParamType, params: FetchParams) {
  return useQuery({
    queryKey: ['fetch-related-users', id, params],
    queryFn: () => GroupApi.fetchUsers(id, params),
  })
}
